import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProgressArrowUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	fillOpacity: 0,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_5018_1118)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.3333 4L8.99999 10.3333L5.66666 7L0.666656 12M15.3333 4H11.3333M15.3333 4L15.3333 8",
			stroke: "#118A5D",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5018_1118",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgProgressArrowUp;
